import OrdersSvg from "../assets/icons/orders.svg";

export const url = {
  homePage: "/",
  login: "/login",
  thankYouPage: "/thank-you-page",
  forgottenPasswordSendMail: "/forgotten-password-send-mail",
  aboutUs: "/about-us",
  forgottenAccountToken: "/forgotten-account/:token",
  offer: "/offer",
  operatorReckoning: "/operator/reckoning",
  regulations: "/regulations",
  faq: "/faq",
  rest: "*",
  orders: "/orders",
  settings: "/settings",
  privacyPolicy: "/privacy-policy",
  help: "/help",
  contact: "/contact",
  test: "/test",
  offerForm: "/offer-form",
  offerFormSummary: "/offer-form/summary",
  offerCreate: "/offer-form/create",
  offerView: "/offer-view",
  offerViewLinkEmailUnloggedClient: "/offer-view/:id/:token24",
  offerViewLinkEmailLoggedClient: "/offer-view/:id",
  finalOfferViewLinkEmailUnloggedClient: "final-offer-view/:id/:token24",
  finalOfferViewLinkEmailLoggedClient: "final-offer-view/:id",
  offerInitialAcceptance: "/offer-initial-acceptance",
  offerViewSubcontractor: "/subcontractor/offer-view/:id",
};
export const urlClient = {
  orderForm: "/order-form",
  orderFormSummary: "/order-form/summary",
  account: "/account",
  offerView: "/offer-view",
  settings: "/client/settings",
  orders: "/orders",
  orderDetails: "/orders/:id",
  offerViewId: "/orders/offer-view/:id",
  finalOfferViewId: "/orders/final-offer-view/:id",
};
export const urlSubcontractor = {
  subcontractors: "/subcontractor/subcontractors",
  subcontractorsDetails: "/subcontractor/subcontractors/data",
  subcontractorsStorageArea: "/subcontractor/subcontractors/storage-area/:id",
  warehouseServices: "/subcontractor/subcontractors/services/:id",
  warehousesPricelist: "/subcontractor/subcontractors/price-list/:id",
  operatorReckoning: "/subcontractor/reckoning",
  storageAreaAvailability:
    "/subcontractor/subcontractors/storage-area-availability/:id",
  storageAreaAvailabilityAdd:
    "/subcontractor/subcontractors/storage-area-availability/add/:id",
  storageAreaAvailabilityEdit:
    "/subcontractor/subcontractors/storage-area-availability/edit/:id",
};
export const urlOperator = {
  adressAdd: "/operator/adress/add",
  clients: "/operator/clients",
  clientsAdd: "/operator/clients/add",
  clientsEdit: "/operator/clients/edit/:id",
  warehouseDelete: "/operator/warehouse/delete/:id",
  operatorUsers: "/operator/users",
  operatorUsersAdd: "/operator/users/add",
  operatorUsersLoginEdit: "/operator/users/edit/login/:id",
  operatorUsersOperatorDataEdit: "/operator/users/edit/operator/data/:id",
  operatorUsersSubcontractorDataEdit:
    "/operator/users/edit/subcontractor/data/:id",
  warehousesPricelist: "/operator/subcontractors/price-list/:id",
  warehousesPricelistEdit: "/operator/subcontractors/price-list/edit/:id",
  warehousesPricelistAdd: "/operator/subcontractors/price-list/add/:id",
  warehouseServices: "/operator/subcontractors/services/:id",
  warehouseGallery: "/operator/subcontractors/gallery/:id",
  orders: "/operator/orders",
  ordersDetails: "/operator/orders/:id",
  ordersOffering: "/operator/orders/offering/:id",
  ordersOfferingPositionEdit: "/operator/orders/offering/position-edit/:id",
  ordersOfferingPositionAdd: "/operator/orders/offering/position-add/:id",
  ordersOfferingOfferEdit: "/operator/orders/offering/offer-edit/:id",
  ordersOfferingPotentialWarehouses:
    "/operator/orders/offering/potential-warehouses/:id",
  subcontractors: "/operator/subcontractors",
  subcontractorsDetails: "/operator/subcontractors/data",
  subcontractorsStorageArea: "/operator/subcontractors/storage-area/:id",
  subcontractorsStorageAreaAdd: "/operator/subcontractors/storage-area/add/:id",
  subcontractorsStorageAreaEdit:
    "/operator/subcontractors/storage-area/edit/:id_magazyn/:id_obszar",
  subcontractorsStorageAreaAvailability:
    "/operator/subcontractors/storage-area-availability/:id",
  subcontractorsStorageAreaAvailabilityAdd:
    "/operator/subcontractors/storage-area-availability/add/:id",
  subcontractorsStorageAreaAvailabilityEdit:
    "/operator/subcontractors/storage-area-availability/edit/:id",
  subcontractorsPackageAdd: "/operator/subcontractors/package/add/:id",
  subcontractorsPackageEdit: "/operator/subcontractors/package/edit/:id",
  subcontractorsAddSubcontractor: "/operator/subcontractors/add-subcontractor",
};
//Uwaga trzeba jeszcze tą uzupełnić albo napisać funkcję;
export const urlArray: string[] = [
  url.homePage,
  url.login,
  url.thankYouPage,
  url.forgottenPasswordSendMail,
  url.aboutUs,
  url.faq,
  url.test,
  url.settings,
  url.help,
  url.contact,
  url.privacyPolicy,
  url.forgottenAccountToken,
  url.operatorReckoning,
  url.regulations,
  url.rest,
  url.orders,
  url.offerForm,
  url.offerFormSummary,
  url.offer,
  url.offerView,
  url.offerInitialAcceptance,
  url.offerViewLinkEmailUnloggedClient,
  url.offerViewLinkEmailLoggedClient,
  url.finalOfferViewLinkEmailUnloggedClient,
  url.finalOfferViewLinkEmailLoggedClient,
  url.offerViewSubcontractor,
  urlOperator.clients,
  urlOperator.clientsEdit,
  urlOperator.orders,
  urlOperator.ordersDetails,
  urlOperator.ordersOffering,
  urlOperator.subcontractors,
  urlOperator.subcontractorsDetails,
  urlOperator.warehousesPricelist,
  urlOperator.warehouseServices,
  urlOperator.subcontractorsStorageArea,
  urlOperator.subcontractorsStorageAreaAdd,
  urlOperator.subcontractorsStorageArea,
  urlOperator.subcontractorsAddSubcontractor,
  urlOperator.ordersOfferingPositionEdit,
  urlOperator.ordersOfferingPositionAdd,
  urlOperator.ordersOfferingOfferEdit,
  urlOperator.subcontractorsPackageAdd,
  urlOperator.subcontractorsPackageEdit,
  urlOperator.ordersOfferingPotentialWarehouses,
  urlOperator.operatorUsers,
  urlOperator.warehouseGallery,
  urlClient.account,
  urlClient.offerView,
  urlClient.offerViewId,
  urlClient.finalOfferViewId,
  urlClient.orderForm,
  urlClient.orderFormSummary,
  urlClient.settings,
  urlClient.orderDetails,
  urlSubcontractor.subcontractors,
  urlSubcontractor.subcontractorsDetails,
  urlSubcontractor.subcontractorsStorageArea,
  urlSubcontractor.warehouseServices,
  urlSubcontractor.warehousesPricelist,
  urlSubcontractor.operatorReckoning,
  urlSubcontractor.storageAreaAvailability,
  urlSubcontractor.storageAreaAvailabilityAdd,
  urlSubcontractor.storageAreaAvailabilityEdit,
];

type Menu = {
  key: number;
  name: string;
  url: string;
  svg?: any;
};

export const navItems: Menu[] = [
  {
    key: 0,
    name: "Strona główna",
    url: url.homePage,
  },
  {
    key: 1,
    name: "Oferta",
    url: url.offer,
  },
  {
    key: 2,
    name: "O nas",
    url: url.aboutUs,
  },
  {
    key: 3,
    name: "Faq",
    url: url.faq,
  },
];

export const navLogedOperator: Menu[] = [
  {
    key: 0,
    name: "Klienci",
    url: urlOperator.clients,
  },
  {
    key: 1,
    name: "Zamówienia i ofertowanie",
    url: urlOperator.orders,
  },
  {
    key: 2,
    name: "Podwykonawcy",
    url: urlOperator.subcontractors,
  },
  {
    key: 3,
    name: "Rozliczenia",
    url: url.operatorReckoning,
  },
  {
    key: 4,
    name: "Użytkownicy",
    url: urlOperator.operatorUsers,
  },
];

export const navLogedSub: Menu[] = [
  {
    key: 0,
    name: "Podwykonawcy",
    url: urlSubcontractor.subcontractors,
  },
  {
    key: 1,
    name: "Rozliczenia",
    url: urlSubcontractor.operatorReckoning,
  },
];

export const navLogedClient: Menu[] = [
  {
    key: 0,
    name: "Zamówienia",
    url: url.orders,
    svg: OrdersSvg,
  },
  {
    key: 1,
    name: "Ustawienia",
    url: urlClient.settings,
  },
  {
    key: 2,
    name: "Konto",
    url: urlClient.account,
  },
  {
    key: 3,
    name: "Pomoc",
    url: url.help,
  },
];

export const navLogeButton: Menu[] = [
  {
    key: 0,
    name: "Zaloguj się",
    url: url.login,
  },
  {
    key: 1,
    name: "Wyloguj się",
    url: url.login,
  },
  {
    key: 2,
    name: "Załóż konto",
    url: url.login,
  },
];
export const visibleMainMenu: string[] = [
  url.homePage,
  url.aboutUs,
  url.faq,
  url.offer,
];
